export class DebugDisplay {
  private frames: number[] = [];
  private lastUpdate = 0;
  private fps = 0;

  tick(): void {
    const now = performance.now();
    this.frames.push(now);

    // Keep only frames from the last second
    while (this.frames.length > 0 && this.frames[0] <= now - 1000) {
      this.frames.shift();
    }

    // Recalculate FPS every 500ms
    if (now - this.lastUpdate >= 500) {
      this.fps = this.frames.length;
      this.lastUpdate = now;
    }
  }

  getFPS(): number {
    return this.fps;
  }

}
